const statusMap = {
  active: "success",
  applied: "success",
  approved: "success",
  available: "success",
  complete: "success",
  completed: "success",
  enabled: "success",
  expired: "danger",
  "in-progress": "info",
  install: "success",
  installing: "success",
  nofraud: "success",
  ok: "success",
  on: "success",
  online: "success",
  open: "success",
  ordered: "success",
  paid: "success",
  pass: "success",
  passed: "success",
  primary: "success",
  running: "success",
  success: "success",
  unused: "success",
  up: "success",
  yes: "success",
  closed: "danger",
  disabled: "danger",
  down: "danger",
  failed: "danger",
  "failed-upgrade": "warning",
  failure: "danger",
  high: "danger",
  inactive: "danger",
  incomplete: "danger",
  no: "danger",
  notok: "danger",
  off: "danger",
  offline: "danger",
  overdue: "danger",
  reboot: "danger",
  upgraded: "success",
  un_installed: "danger",
  urgent: "danger",
  used: "danger",
  "verify-id": "danger",
  verified: "success",
  unpaid: "warning",
  allocated: "warning",
  degraded: "warning",
  destroying: "warning",
  fail: "warning",
  fraud: "warning",
  idle: "warning",
  suspended: "warning",
  unapplied: "warning",
  unavailable: "warning",
  waiting: "warning",
  cancelled: "dark",
  denied: "dark",
  void: "dark",
  creating: "info",
  neutral: "info",
  normal: "info",
  now_due: "info",
  pending: "info",
  "pending-user": "warning",
  "ready-to-use": "success",
  received: "info",
  resizing: "info",
  web_active: "info",
  locked: "info",
};

const getStatusVariant = (status) => statusMap[status] ?? "primary";

export { getStatusVariant };
